module.exports = __webpack_public_path__ + "img/BlueArrowDownIcon.0f7dd8aa.svg";